import * as React from 'react';

import Scribble16 from './Scribble16';

export const scribble16 = () => <Scribble16 />;

export default {
    title: 'Icon/Fill/Scribble16',
    component: Scribble16,
    parameters: {
        notes: "`import Scribble16 from 'box-ui-elements/es/icon/fill/Scribble16';`",
    },
};
